import { api } from 'domains/api';
import { BASE_API_ROUTES, getBaseAPIRoute } from 'domains/api/base/routes';
import { FullClient } from './types';

export const getClientInformation = (contactId: string, clientId: string): Promise<FullClient> => {
  return api.base.get<FullClient>(
    getBaseAPIRoute(BASE_API_ROUTES.contacts[':contactId'].clients[':clientId'].info, {
      contactId,
      clientId,
    }),
  );
};
